import { render } from "./WhiteButton.vue?vue&type=template&id=a5743912"
import script from "./WhiteButton.vue?vue&type=script&lang=js"
export * from "./WhiteButton.vue?vue&type=script&lang=js"

import exportComponent from "/home/noe/Dev/atc/agrotecchain_vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__